import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Createaccount from './components/Createaccount';
import Footer from './components/Footer';
import Login from './components/login';
import Homeframes from './components/Homeframes';
import Homehmade from './components/homeparts';
import Homeseller from './components/Homebseller';
import Homepotrait from './components/Homepotrait';
import store from './store/store';
import { Provider } from 'react-redux';
import Cart from './components/Cart';
import ProtectedRoute from './components/Protectedroute';
import Logout from './components/logout';
import { HelmetProvider } from 'react-helmet-async';
import Homeproduct from './components/Homeproduct';
import Search from './components/Search';
import Sujith from './components/Sujith';
import Cartt from './components/Cartt';
import Home from './components/home';
import Collection from './components/Collection';





function App() {

  return (
    <Provider store={store}>

      <BrowserRouter>
        <HelmetProvider>

          <Header> </Header>
          <Routes>
              <Route path='/' element={<Home></Home>}></Route>
              <Route path='/leegifts-ecommerce' element={<Home></Home>}></Route>
          </Routes>
          <div className='container'>
            <Routes>
              
              <Route path='/createaccount' element={<Createaccount> </Createaccount>} >  </Route>
              <Route path='/login' element={<Login> </Login>}> </Route>
              <Route path='/frames' element={<Homeframes> </Homeframes>}></Route>
              <Route path='/handmade-gifts' element={<Homehmade></Homehmade>}></Route>
              <Route path='/best-seller' element={<Homeseller> </Homeseller>}></Route>
              <Route path='/potrait-arts' element={<Homepotrait></Homepotrait>}></Route>
              <Route path='/cart' element={<ProtectedRoute> <Cartt> </Cartt> </ProtectedRoute>}></Route>
              <Route path='/logout' element={<Logout> </Logout>}> </Route>
              <Route path='/product/:id' element={<Homeproduct> </Homeproduct>}> </Route>
              <Route path='/search/:keywordvalue' element={<Search> </Search>}> </Route>
              <Route path='/collection' element={<Collection> </Collection>}> </Route>
              


            </Routes>

          </div>

          <Footer> </Footer> </HelmetProvider>

      </BrowserRouter>

    </Provider>



  );
}

export default App;
